// extracted by mini-css-extract-plugin
module.exports = {"MenuColumnLink":"styles_MenuColumnLink__uLohw","link":"styles_link__05nxc typography_FooterLink__PgM59","darkMode":"styles_darkMode__V9Amn","tag":"styles_tag__p1K64"};